import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'

function StatusBadge({ ok }: { ok: boolean }) {
  return (
    <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${ok ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
      {ok ? 'OK' : 'ERROR'}
    </span>
  )
}

export default function DemoStatusPage() {
  const posting = useQuery({
    queryKey: ['demo-status', 'posting'],
    queryFn: async () => {
      const r = await api.health()
      return r.data
    },
    refetchInterval: 15000,
  })

  const auth = useQuery({
    queryKey: ['demo-status', 'auth'],
    queryFn: async () => {
      const r = await fetch('/auth/health')
      if (!r.ok) throw new Error('auth unavailable')
      return r.json()
    },
    refetchInterval: 15000,
  })

  const jobApi = useQuery({
    queryKey: ['demo-status', 'job-api'],
    queryFn: async () => {
      const r = await fetch('/jobs/health')
      if (!r.ok) throw new Error('job-api unavailable')
      return r.json()
    },
    refetchInterval: 15000,
  })

  const rows = [
    { name: 'Posting API', query: posting },
    { name: 'Auth API', query: auth },
    { name: 'Jobs API', query: jobApi },
  ]

  return (
    <div className="container mx-auto p-6 max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Demo Status</h1>
        <p className="text-sm text-gray-500 mt-1">Live readiness checks for the Diamond Dispatch demo flow.</p>
      </div>

      <div className="bg-white rounded-xl border divide-y">
        {rows.map(row => {
          const isLoading = row.query.isLoading
          const isError = row.query.isError
          const ok = !isLoading && !isError
          return (
            <div key={row.name} className="p-4 flex items-center justify-between">
              <div>
                <div className="font-medium text-gray-900">{row.name}</div>
                <div className="text-xs text-gray-500">
                  {isLoading && 'Checking...'}
                  {isError && 'Service check failed'}
                  {ok && 'Healthy'}
                </div>
              </div>
              <StatusBadge ok={ok} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
